import config from './config';
import settings from '../utils/settings';
import fetchJSON from '../utils/fetch/fetchJSON';
import warn from '../utils/warnings/warn';
import memoize from '../utils/fp/memoize';
import isOnSchedule from '../utils/dates/isOnSchedule';

/* eslint no-console: 0 */

const env = settings.isProd ? '' : '.stg';

/**
 * @public
 * Gets a configuration from HealthCare.com CDN which exposes available call hours for EST timezone.
 * The promise returns if phone numbers can be shown or not.
 *
 * @returns {Promise}
 */
function showPhoneNumber() {
  const url = `${config.cdn}resources/call-hours_configuration${env}.json`;
  let responseData = null;
  return fetchJSON(url, {
    method: 'GET',
  })
    .then((response) => {
      responseData = response;
      if (!response.Default) {
        throw new Error('Call hours configuration file does not exist or doesn\'t have a Default object');
      }

      return isOnSchedule(response.Default);
    })
    .catch((error) => {
      warn(error, {
        url,
        data: {
          responseData,
        },
      });

      return true;
    });
}

export default memoize(showPhoneNumber);
